﻿// 全局主题默认配置
import type { ThemeConfig } from '@/types'

export const defaultTheme: ThemeConfig = {
  primaryColor: '#1677ff',
  borderRadius: '12px',
  cardBorderRadius: '16px',
  shadow: '0 2px 12px rgba(0,0,0,0.05)',
  pageBg: '#f7f8fa',
  darkMode: false,
  layoutMode: 'sidebar',
  collapsed: false,
}
